import { SelectableButton } from 'app/components/selectable-button';
import { styled, css } from 'styled-components';

export const StyledClassificationButton = styled(SelectableButton)<{ $isSelected: boolean; $isAiClassified: boolean }>`
  background-color: ${({ theme }) => theme.colors.mono.ui04};
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      color: ${({ theme }) => theme.colors.mono.text01};
      background-color: ${({ theme }) => theme.colors.brand.brand01};
    `}
  ${({ $isAiClassified }) =>
    $isAiClassified &&
    css`
      background-image: linear-gradient(to right, #7e25c4, #f50182);
      color: ${({ theme }) => theme.colors.mono.text01};
    `}
`;
